const state = {
    ticketData: [
        {
            id: 1,
            sp: '北京',
            ep: '香港',
            iconimg: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
            name: '香港航空',
            type: 'HX337 空客330(大)',
            stime: '11:55',
            ssp: "首都国际机场T2",
            etime: '15:55',
            esp: '香港国际机场T1',
            delayTime: '4',
            isSuoper: false,
            types: [
                { id: '11', name: '经济舱', money: '1660', tips: '赠￥30外币满减券' },
                { id: '12', name: '超级经济舱', money: '1560', tips: '托运行李额更多' },
            ]
        },
        {
            id: 2,
            sp: '北京',
            ep: '香港',
            iconimg: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
            name: '香港航空',
            type: 'HX337 空客330(大)',
            stime: '11:55',
            ssp: "首都国际机场T2",
            etime: '15:55',
            esp: '香港国际机场T1',
            delayTime: '4',
            isSuoper: false,

            types: [
                { id: '11', name: '经济舱', money: '1660', tips: '赠￥30外币满减券' },
                { id: '12', name: '超级经济舱', money: '1560', tips: '托运行李额更多' },
            ]
        },
        {
            id: 3,
            sp: '北京',
            ep: '香港',
            iconimg: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
            name: '香港航空',
            type: 'HX337 空客330(大)',
            stime: '11:55',
            ssp: "首都国际机场T2",
            etime: '15:55',
            esp: '香港国际机场T1',
            delayTime: '4',
            isSuoper: false,

            types: [
                { id: '11', name: '经济舱', money: '1660', tips: '赠￥30外币满减券' },
                { id: '12', name: '超级经济舱', money: '1560', tips: '托运行李额更多' },
            ]
        },
        {
            id: 4,
            sp: '广州',
            ep: '北京',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/MU.png',
            name: '东方航空',
            type: 'KN5830 波音73V(中)',
            stime: '16:35',
            ssp: "白云机场T",
            etime: '21:40',
            esp: '首都机场T2',
            delayTime: '5',
            isSuoper: false,
            types: [
                { id: '11', name: '经济舱', money: '558', tips: '赠￥30外币满减券' },
                { id: '12', name: '超级经济舱', money: '1230', tips: '托运行李额更多' },
            ]
        },
        {
            id: 5,
            isSuoper: false,


            sp: '广州',
            ep: '北京',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/HU.png',
            name: '海南航空',
            type: 'MU5282 空客330(大)',
            stime: '21:15',
            ssp: "白云机场T",
            etime: '00:05',
            esp: '首都机场T2',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '871', tips: '赠￥30外币满减券' },
                { id: '12', name: '超级经济舱', money: '890', tips: '托运行李额更多' },
            ]
        },
        {
            id: 6,
            isSuoper: false,
            sp: '广州',
            ep: '北京',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/MU.png',
            name: '东方航空',
            type: 'MU6622波音737-800(中)',
            stime: '07:55',
            ssp: "白云机场T",
            etime: '10:55',
            esp: '大兴机场',
            delayTime: '3',
            types: [
                { id: '11', name: '经济舱', money: '1660', tips: '赠￥30外币满减券' },
                { id: '12', name: '超级经济舱', money: '1560', tips: '托运行李额更多' },
            ]
        },
        {
            id: 7,
            sp: '北京',
            ep: '深圳',
            isSuoper: false,
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/MU.png',
            name: '东方航空',
            type: 'MU6669 波音73V(中)',
            stime: '21:15',
            ssp: "大兴机场",
            etime: '00:25',
            esp: '宝安机场T3',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '669', tips: '赠￥30外币满减券' },
                { id: '12', name: '超级经济舱', money: '771', tips: '托运行李额更多' },
            ]
        },
        {
            id: 8,
            sp: '北京',
            ep: '深圳',
            isSuoper: false,
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/KN.png',
            name: '联合航空',
            type: 'KN5867 波音73V(中)',
            stime: '09:30',
            ssp: "大兴机场",
            etime: '14:40',
            esp: '香宝安机场T3',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '669', tips: '赠￥30外币满减券' },
                { id: '12', name: '超级经济舱', money: '1120', tips: '托运行李额更多' },
            ]
        },
        {
            id: 9,
            sp: '北京',
            ep: '深圳',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/KN.png',
            name: '联合航空',
            type: 'KN5855 波音73V(中)',
            stime: '07:05',
            ssp: "大兴机场",
            etime: '10:15',
            esp: '宝安机场T3',
            delayTime: '3',
            types: [
                { id: '11', name: '经济舱', money: '1660', tips: '赠￥30外币满减券' },
                { id: '12', name: '超级经济舱', money: '1560', tips: '托运行李额更多' },
            ]
        },
        {
            id: 10,
            sp: '北京',
            ep: '上海',
            isSuoper: false,
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/HO.png',
            name: '吉祥航空',
            type: 'HO1254 全新A320',
            stime: '08:20',
            ssp: "大兴机场",
            etime: '10:35',
            esp: '浦东机场T2',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '348', tips: '赠￥30外币满减券' },
                { id: '12', name: '超级经济舱', money: '350', tips: '托运行李额更多' },
            ]
        },
        {
            id: 11,
            sp: '北京',
            ep: '上海',
            isSuoper: false,
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/CZ.png',
            name: '南方航空',
            type: 'CZ8982 空客330(大)',
            stime: '20:35',
            ssp: "大兴机场",
            etime: '23:00',
            esp: '浦东机场T2',
            delayTime: '2',
            types: [
                { id: '11', name: '经济舱', money: '467', tips: '赠￥30外币满减券' },
                { id: '12', name: '超级经济舱', money: '400', tips: '托运行李额更多' },
            ]
        },
        {
            id: 12,
            sp: '北京',
            ep: '上海',
            isSuoper: false,
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/KN.png',
            name: '联合航空',
            type: 'KN5977 波音737(中)',
            stime: '18:20',
            ssp: "大兴机场",
            etime: '21:00',
            esp: '浦东机场T1',
            delayTime: '2',
            types: [
                { id: '11', name: '经济舱', money: '368', tips: '赠￥30外币满减券' },
                { id: '12', name: '超级经济舱', money: '489', tips: '托运行李额更多' },
            ]
        },
        {
            id: 13,
            sp: '北京',
            ep: '首尔',
            isSuoper: false,
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/KE.png.c-ctrip.com/flight_intl/airline_logo/40x35/CZ.png',
            name: '大韩航空',
            type: 'KE866 空客380(大)',
            stime: '13:20',
            ssp: "白云机场T2",
            etime: '17:30',
            esp: '仁川机场T2',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '2518', tips: '赠￥30外币满减券' },
                { id: '12', name: '超级经济舱', money: '489', tips: '托运行李额更多' },
            ]
        },
        {
            id: 14,
            sp: '杭州',
            ep: '东京',
            isSuoper: false,
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/CA.png',
            name: '中国国航',
            type: 'CA145 空客321(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '2518', tips: '赠￥30外币满减券' },
                { id: '12', name: '超级经济舱', money: '489', tips: '托运行李额更多' },
            ]
        },
        {
            id: 15,
            sp: '杭州',
            ep: '东京',
            isSuoper: false,
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/CZ.png',
            name: '南方航空',
            type: 'CA145 空客321(中)',
            stime: '20:30',
            ssp: "萧山国际机场",
            etime: '12:25',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '9900', tips: '赠￥30外币满减券' },
                { id: '12', name: '超级经济舱', money: '11102', tips: '托运行李额更多' },
            ]
        },
        {
            id: 16,
            sp: '杭州',
            ep: '东京',
            isSuoper: false,
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/CA.png',
            name: '南方航空',
            type: 'CA145 空客320(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '5546', tips: '赠￥30外币满减券' },
                { id: '12', name: '超级经济舱', money: '6531', tips: '托运行李额更多' },
            ]
        },
        {
            id: 17,
            sp: '杭州',
            ep: '东京',
            isSuoper: false,
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/CA.png',
            name: '南方航空',
            type: 'CA145 空客321(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '5546', tips: '赠￥30外币满减券' },
                { id: '12', name: '超级经济舱', money: '6531', tips: '托运行李额更多' },
            ]
        },

        //从特价机票处的数据
        {
            id: 18,
            sp: '广州',
            isSuoper: true,
            ep: '北京',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/MU.png',
            name: '东方航空',
            type: 'MU5282 空客A33L(大)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '326', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 19,
            sp: '广州',
            isSuoper: true,
            ep: '成都',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/CA.png',
            name: '南方航空',
            type: 'CA145 空客321(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '398', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 20,
            sp: '广州',
            isSuoper: true,
            ep: '哈尔滨',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/ZH.png',
            name: '深圳航空',
            type: 'ZH9675 空客A320(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '298', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 21,
            isSuoper: true,
            sp: '广州',
            ep: '天津',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/AQ.png',
            name: '九元航空',
            type: 'AQ1055 空客320(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '288', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 22,
            sp: '广州',
            isSuoper: true,
            ep: '沈阳',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/AQ.png',
            name: '九元航空',
            type: 'AQ1059 波音738(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '198', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 23,
            sp: '广州',
            isSuoper: true,
            ep: '呼和浩特',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/GJ.png',
            name: '长龙航空',
            type: 'GJ8567 空客321(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '228', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 24,
            isSuoper: true,
            sp: '广州',
            ep: '杭州',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/CZ.png',
            name: '南方航空',
            type: 'CZ5647 空客321(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '298', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 25,
            isSuoper: true,
            sp: '广州',
            ep: '太原',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/HU.png',
            name: '南方航空',
            type: 'CA145 空客321(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '198', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 26,
            sp: '广州',
            isSuoper: true,
            ep: '长春',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/CA.png',
            name: '九元航空',
            type: 'AQ1033 波音738(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '458', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 27,
            sp: '广州',
            isSuoper: true,
            ep: '石家庄',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/GJ.png',
            name: '长龙航空',
            type: 'GJ8911 空客A320(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '198', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 27,
            sp: '广州',
            isSuoper: true,
            ep: '厦门',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/SC.png',
            name: '山东航空',
            type: 'GJ8911 空客A320(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '198', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 28,
            sp: '广州',
            isSuoper: true,
            ep: '大连',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/HU.png',
            name: '海南航空',
            type: 'HU7244 波音737-800(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '198', tips: '赠￥30外币满减券' },
            ]
        },
        //出发点是北京
        {
            id: 29,
            sp: '北京',
            isSuoper: true,
            ep: '太原',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/MU.png',
            name: '东方航空',
            type: 'MU5300 波音737-800（小翼）(小)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '198', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 30,
            sp: '北京',
            isSuoper: true,
            ep: '长春',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/CA.png',
            name: '中国国航',
            type: 'CA8331 波音73K(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '198', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 31,
            sp: '北京',
            isSuoper: true,
            ep: '杭州',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/CA.png',
            name: '海南航空',
            type: 'HU7177 波音737-800(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '198', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 32,
            sp: '北京',
            isSuoper: true,
            ep: '合肥',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/MU.png',
            name: '东方航空',
            type: 'MU5172 空客A320(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '286', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 33,
            sp: '北京',
            isSuoper: true,
            ep: '大连',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/CA.pn',
            name: '中国国航',
            type: 'CA1607 波音73D(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '286', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 34,
            sp: '北京',
            isSuoper: true,
            ep: '哈尔滨',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/CA.png',
            name: '中国国航',
            type: 'CA1621 空客A320(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '286', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 35,
            sp: '北京',
            isSuoper: true,
            ep: '厦门',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/SC.png',
            name: '山东航空',
            type: 'SC2130 波音737-800(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '286', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 36,
            sp: '北京',
            isSuoper: true,
            ep: '青岛',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/MU.png',
            name: '山东航空',
            type: 'MU6965 空客A321(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '286', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 37,
            sp: '北京',
            isSuoper: true,
            ep: '沈阳',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/CA.png',
            name: '中国国航',
            type: 'CA819 空客A321(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '286', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 38,
            sp: '北京',
            isSuoper: true,
            ep: '上海',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/CZ.png',
            name: '南方航空',
            type: 'CZ8982 空客A330(大)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '458', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 39,
            sp: '北京',
            isSuoper: true,
            ep: '南京',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/MU.png',
            name: '东方航空',
            type: 'MU2802 空客A320(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '458', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 40,
            sp: '北京',
            isSuoper: true,
            ep: '郑州',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/CA.png',
            name: '中国国航',
            type: 'CA1391 波音73K(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '458', tips: '赠￥30外币满减券' },
            ]
        },
        //从上海出发
        {
            id: 41,
            sp: '上海',
            isSuoper: true,
            ep: '北京',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/HO.png',
            name: '吉祥航空',
            type: 'HO1253 全新A320',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '161', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 42,
            sp: '上海',
            isSuoper: true,
            ep: '大连',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/MU.png',
            name: '吉祥航空',
            type: 'MU5661 空客A320-300(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '365', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 43,
            sp: '上海',
            isSuoper: true,
            ep: '哈尔滨',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/MU.png',
            name: '四川航空',
            type: 'HU7177 空客321(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '247', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 44,
            sp: '上海',
            isSuoper: true,
            ep: '天津',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/9C.png',
            name: '春秋航空',
            type: '9C8869 空客320(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '278', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 45,
            sp: '上海',
            isSuoper: true,
            ep: '沈阳',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/FM.png',
            name: '上海航空',
            type: 'FM9169 波音738(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '206', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 46,
            sp: '上海',
            isSuoper: true,
            ep: '呼和浩特',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/CA.png',
            name: '中国国航',
            type: 'CA1666 波音737-800(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '206', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 46,
            sp: '上海',
            isSuoper: true,
            ep: '南京',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/MU.png',
            name: '东方航空',
            type: 'MU2882 空客A320(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '288', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 47,
            sp: '上海',
            isSuoper: true,
            ep: '太原',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/MU.png',
            name: '东方航空',
            type: 'MU2882 空客A320(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '293', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 48,
            sp: '上海',
            isSuoper: true,
            ep: '长春',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/9C.png',
            name: '春秋航空',
            type: '9C8809 空客320(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '293', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 49,
            sp: '上海',
            isSuoper: true,
            ep: '石家庄',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/9C.png',
            name: '春秋航空',
            type: '9C8903 空客320(中)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '293', tips: '赠￥30外币满减券' },
            ]
        },
        {
            id: 50,
            sp: '上海',
            isSuoper: true,
            ep: '合肥',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/MU.png',
            name: '东方航空',
            type: 'MU9105 新支线 ARJ21(小)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '293', tips: '赠￥30外币满减券' },
            ]
        },

        //首页的特价机票部分
        {
            id: 51,
            sp: '上海',
            ep: '合肥',
            iconimg: '//pic.c-ctrip.com/flight_intl/airline_logo/40x35/MU.png',
            name: '东方航空',
            type: 'MU9105 新支线 ARJ21(小)',
            stime: '09:50',
            ssp: "萧山国际机场",
            etime: '13:50',
            esp: '成田国际机场T1',
            delayTime: '4',
            types: [
                { id: '11', name: '经济舱', money: '293', tips: '赠￥30外币满减券' },
            ]
        },
    ],
    buyTicketData: [],


    //首页的预定数据
    ticketArr:
        [
        {
        id: 1,
        name: 'beijing',
        childData: [{
            label: 'top',
            data: [{
                startAdd: '北京',
                endAdd: '重庆',
                time: '2月24日',
                price: '200',
                title: '香港航空 HX337 空客330(大)',
                type: 'HX337 空客330(大)',
                src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',

            },
                {
                    startAdd: '北京',
                    endAdd: '郑州',
                    time: '2月25日',
                    price: '625',
                    title: '香港航空 HX337 空客330(大)',
                    type: 'HX337 空客330(大)',
                    src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                },
                {
                    startAdd: '北京',
                    endAdd: '武汉',
                    time: '2月25日',
                    price: '98',
                    title: '香港航空 HX337 空客330(大)',
                    type: 'HX337 空客330(大)',
                    src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                },
                {
                    startAdd: '北京',
                    endAdd: '福建',
                    time: '2月25日',
                    price: '102',
                    title: '香港航空 HX337 空客330(大)',
                    type: 'HX337 空客330(大)',
                    src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                },
                {
                    startAdd: '北京',
                    endAdd: '重庆',
                    time: '2月24日',
                    price: '200',
                    title: '香港航空 HX337 空客330(大)',
                    type: 'HX337 空客330(大)',
                    src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                },
                {
                    startAdd: '北京',
                    endAdd: '郑州',
                    time: '2月25日',
                    price: '625',
                    title: '香港航空 HX337 空客330(大)',
                    type: 'HX337 空客330(大)',
                    src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                },
                { startAdd: '北京', endAdd: '武汉', time: '2月25日', price: '98' },
                { startAdd: '北京', endAdd: '福建', time: '2月25日', price: '102' },
            ]
        },
            {
                label: 'right',
                data: [
                    { startAdd: '北京', endAdd: '天津', time: '2月25日', price: '98' },
                    { startAdd: '北京', endAdd: '成都', time: '2月25日', price: '109' },
                    { startAdd: '北京', endAdd: '兴义', time: '2月25日', price: '98' },
                    { startAdd: '北京', endAdd: '湖北', time: '2月24日', price: '225' },
                    { startAdd: '北京', endAdd: '山西', time: '2月24日', price: '169' },
                    { startAdd: '北京', endAdd: '成都', time: '2月28日', price: '199' },
                    { startAdd: '北京', endAdd: '湖南', time: '2月23日', price: '115' },
                ]
            },
            {
                label: 'bottom',
                data: [
                    { startAdd: '北京', endAdd: '天津', time: '2月25日', price: '98' },
                    { startAdd: '北京', endAdd: '成都', time: '2月25日', price: '109' },
                    { startAdd: '北京', endAdd: '兴义', time: '2月25日', price: '98' },
                    { startAdd: '北京', endAdd: '湖北', time: '2月24日', price: '225' },
                    { startAdd: '北京', endAdd: '山西', time: '2月24日', price: '169' },
                    { startAdd: '北京', endAdd: '成都', time: '2月28日', price: '199' },
                    { startAdd: '北京', endAdd: '湖南', time: '2月23日', price: '115' },
                ]
            },
            {
                label: 'left',
                data: [
                    { startAdd: '北京', endAdd: '天津', time: '2月25日', price: '98' },
                    { startAdd: '北京', endAdd: '成都', time: '2月25日', price: '109' },
                    { startAdd: '北京', endAdd: '兴义', time: '2月25日', price: '98' },
                    { startAdd: '北京', endAdd: '湖北', time: '2月24日', price: '225' },
                    { startAdd: '北京', endAdd: '山西', time: '2月24日', price: '169' },
                    { startAdd: '北京', endAdd: '成都', time: '2月28日', price: '199' },
                    { startAdd: '北京', endAdd: '湖南', time: '2月23日', price: '115' },
                ]
            },
        ]
    },
        {
            id: 2,
            name: 'chongqing',
            childData: [{
                label: 'top',
                data: [
                    { startAdd: '重庆', endAdd: '北京', time: '2月24日', price: '98' },
                    { startAdd: '重庆', endAdd: '武汉', time: '2月25日', price: '98' },
                    { startAdd: '重庆', endAdd: '武汉', time: '2月25日', price: '98' },
                    { startAdd: '重庆', endAdd: '上海', time: '2月25日', price: '102' },
                    { startAdd: '重庆', endAdd: '天津', time: '2月25日', price: '98' },
                ]
            },
                {
                    label: 'right',
                    data: [
                        { startAdd: '重庆', endAdd: '北京', time: '2月24日', price: '98' },
                        { startAdd: '重庆', endAdd: '武汉', time: '2月25日', price: '98' },
                        { startAdd: '重庆', endAdd: '武汉', time: '2月25日', price: '98' },
                        { startAdd: '重庆', endAdd: '上海', time: '2月25日', price: '102' },
                    ]
                },
                {
                    label: 'bottom',
                    data: [
                        { startAdd: '重庆', endAdd: '天津', time: '2月25日', price: '98' },
                        { startAdd: '重庆', endAdd: '成都', time: '2月25日', price: '98' },
                        { startAdd: '重庆', endAdd: '成都', time: '2月25日', price: '98' },
                        { startAdd: '重庆', endAdd: '山西', time: '2月24日', price: '75' },
                    ]
                },
                {
                    label: 'left',
                    data: [
                        { startAdd: '重庆', endAdd: '山西', time: '2月24日', price: '75' },
                        { startAdd: '重庆', endAdd: '南京', time: '2月28日', price: '98' },
                        { startAdd: '重庆', endAdd: '兰州', time: '2月23日', price: '115' },
                    ]
                },
            ]
        },
        {
            id: 3,
            name: 'shanghai',
            childData: [{
                label: 'top',
                data: [{
                    startAdd: '上海',
                    endAdd: '吉林',
                    time: '2月24日',
                    price: '98',
                    title: '香港航空 HX337 空客330(大)',
                    type: 'HX337 空客330(大)',
                    src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                },
                    {
                        startAdd: '上海',
                        endAdd: '江苏',
                        time: '2月25日',
                        price: '98',
                        title: '香港航空 HX337 空客330(大)',
                        type: 'HX337 空客330(大)',
                        src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                    },
                    {
                        startAdd: '上海',
                        endAdd: '松原',
                        time: '2月25日',
                        price: '98',
                        title: '香港航空 HX337 空客330(大)',
                        type: 'HX337 空客330(大)',
                        src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                    },
                    {
                        startAdd: '上海',
                        endAdd: '邳州',
                        time: '2月25日',
                        price: '102',
                        title: '香港航空 HX337 空客330(大)',
                        type: 'HX337 空客330(大)',
                        src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                    },
                    {
                        startAdd: '上海',
                        endAdd: '天津',
                        time: '2月25日',
                        price: '98',
                        title: '香港航空 HX337 空客330(大)',
                        type: 'HX337 空客330(大)',
                        src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                    },
                ]
            },
                {
                    label: 'right',
                    data: [{
                        startAdd: '上海',
                        endAdd: '吉林',
                        time: '2月24日',
                        price: '98',
                        title: '香港航空 HX337 空客330(大)',
                        type: 'HX337 空客330(大)',
                        src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                    },
                        {
                            startAdd: '上海',
                            endAdd: '江苏',
                            time: '2月25日',
                            price: '98',
                            title: '香港航空 HX337 空客330(大)',
                            type: 'HX337 空客330(大)',
                            src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                        },
                        {
                            startAdd: '上海',
                            endAdd: '松原',
                            time: '2月25日',
                            price: '98',
                            title: '香港航空 HX337 空客330(大)',
                            type: 'HX337 空客330(大)',
                            src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                        },
                        {
                            startAdd: '上海',
                            endAdd: '邳州',
                            time: '2月25日',
                            price: '102',
                            title: '香港航空 HX337 空客330(大)',
                            type: 'HX337 空客330(大)',
                            src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                        },
                        {
                            startAdd: '上海',
                            endAdd: '天津',
                            time: '2月25日',
                            price: '98',
                            title: '香港航空 HX337 空客330(大)',
                            type: 'HX337 空客330(大)',
                            src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                        },
                    ]
                },
                {
                    label: 'bottom',
                    data: [{
                        startAdd: '上海',
                        endAdd: '井冈山',
                        time: '2月25日',
                        price: '98',
                        title: '香港航空 HX337 空客330(大)',
                        type: 'HX337 空客330(大)',
                        src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                    },
                        {
                            startAdd: '上海',
                            endAdd: '营口',
                            time: '2月25日',
                            price: '98',
                            title: '香港航空 HX337 空客330(大)',
                            type: 'HX337 空客330(大)',
                            src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                        },
                        {
                            startAdd: '上海',
                            endAdd: '山西',
                            time: '2月24日',
                            price: '75',
                            title: '香港航空 HX337 空客330(大)',
                            type: 'HX337 空客330(大)',
                            src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                        },
                    ]
                },
                {
                    label: 'left',
                    data: [{
                        startAdd: '上海',
                        endAdd: '原平',
                        time: '2月24日',
                        price: '75',
                        title: '香港航空 HX337 空客330(大)',
                        type: 'HX337 空客330(大)',
                        src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                    },
                        {
                            startAdd: '上海',
                            endAdd: '日照',
                            time: '2月28日',
                            price: '98',
                            title: '香港航空 HX337 空客330(大)',
                            type: 'HX337 空客330(大)',
                            src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                        },
                        {
                            startAdd: '上海',
                            endAdd: '兰州',
                            time: '2月23日',
                            price: '115',
                            title: '香港航空 HX337 空客330(大)',
                            type: 'HX337 空客330(大)',
                            src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                        },
                    ]
                },
            ]
        },
        //特价机票新增的数据
        // 1.从广州出发
        {
            id: 4,
            name: 'guangzhou', //出发地
            childData: [{
                label: 'top', //可以选择不变
                data: [{
                    startAdd: '广州', //出发地
                    endAdd: '北京', //目的的
                    time: '2月24日', //模拟时间，可以不变
                    price: '326', //价格
                    title: '香港航空 HX337 空客330(大)', //对应的名字，你去看布局里面，对应的哪里，然后更改
                    type: 'HX337 空客330(大)',
                    src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',

                },
                    {
                        startAdd: '广州', //出发地
                        endAdd: '北京', //目的的
                        time: '2月24日', //模拟时间，可以不变
                        price: '326', //价格
                        title: '香港航空 HX337 空客330(大)', //对应的名字，你去看布局里面，对应的哪里，然后更改
                        type: 'HX337 空客330(大)',
                        src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',

                    },
                    {
                        startAdd: '广州',
                        endAdd: '大连',
                        time: '2月25日',
                        price: '365',
                        title: '香港航空 HX337 空客330(大)',
                        type: 'HX337 空客330(大)',
                        src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                    },
                    {
                        startAdd: '广州',
                        endAdd: '成都',
                        time: '2月25日',
                        price: '198',
                        title: '香港航空 HX337 空客330(大)',
                        type: 'HX337 空客330(大)',
                        src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                    },
                    {
                        startAdd: '广州',
                        endAdd: '上海',
                        time: '2月25日',
                        price: '102',
                        title: '香港航空 HX337 空客330(大)',
                        type: 'HX337 空客330(大)',
                        src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                    },
                    {
                        startAdd: '广州',
                        endAdd: '重庆',
                        time: '2月24日',
                        price: '200',
                        title: '香港航空 HX337 空客330(大)',
                        type: 'HX337 空客330(大)',
                        src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                    },
                    {
                        startAdd: '广州',
                        endAdd: '郑州',
                        time: '2月25日',
                        price: '625',
                        title: '香港航空 HX337 空客330(大)',
                        type: 'HX337 空客330(大)',
                        src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                    },
                    {
                        startAdd: '广州',
                        endAdd: '武汉',
                        time: '2月25日',
                        price: '265',
                        title: '香港航空 HX337 空客330(大)',
                        type: 'HX337 空客330(大)',
                        src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                    },
                    {
                        startAdd: '广州',
                        endAdd: '福建',
                        time: '2月25日',
                        price: '102',
                        title: '香港航空 HX337 空客330(大)',
                        type: 'HX337 空客330(大)',
                        src: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2434733526,193384680&fm=26&gp=0.jpg',
                    },
                ]
            }, ]
        },
    ],
}
const mutations = {
    changebuyTicketData(state, obj) {
        state.buyTicketData.push(obj)
    }
}
const actions = {
    actionTicket({ commit }, obj) {
        commit('changebuyTicketData', obj)
    }
}
export default {
    state,
    mutations,
    actions,
}